import { httpClient } from "@sazka/utils/http-clients/http-client";

document.ready(() => {
    const root = document.getElementById("send-sms-root");
    if (!root) return;

    const input = root.querySelector("input");
    const submitBtn = root.querySelector("#btn-submit");
    const appCode = submitBtn.getAttribute("data-app");

    const wrapperElement = root.querySelector<HTMLElement>(".send-sms-wrapper");

    const labelElements = root.querySelectorAll<HTMLElement>(".send-sms__label");

    const errorElement = root.querySelector<HTMLElement>(".send-sms__label--error");
    const successElement = root.querySelector<HTMLElement>(".send-sms__label--success");
    const validationElement = root.querySelector<HTMLElement>(".send-sms__label--validation");

    const formatInput = () => {
        let val = input.value;

        // Remove all non-digit characters (including existing spaces)
        val = val.replace(/\D/g, "");

        // Format the input into groups of three digits from the left side
        let formattedInput = val.replace(/(\d{3})(?=\d)/g, "$1 ");

        // Ensure no trailing space if the number of digits is a multiple of three
        if (val.length % 3 === 0) {
            formattedInput = formattedInput.trim();
        }

        input.value = formattedInput;
    };

    const validateInput = () => {
        const val = input.value;
        const validationRegex = /^(\+420|00420)?[ ]*([0-9][ ]*){9}$/;
        return validationRegex.test(val);
    };

    const validate = () => {
        const isValid = validateInput();
        if (validationElement) {
            validationElement.style.display = isValid ? "none" : "block";
            validationElement.style.opacity = isValid ? "0" : "1";
        }
        if (wrapperElement) {
            if (isValid) {
                wrapperElement.classList.remove("error");
            } else {
                wrapperElement.classList.add("error");
            }
        }
        return isValid;
    };

    const resetStateLabels = () => {
        if (labelElements) {
            labelElements.forEach((label) => {
                label.style.display = "none";
                label.style.opacity = "0";
            });
        }
        if (wrapperElement) {
            wrapperElement.classList.remove("success");
            wrapperElement.classList.remove("error");
        }
    };

    const showError = () => {
        if (errorElement) {
            errorElement.style.display = "block";
            errorElement.style.opacity = "1";
        }
        if (wrapperElement) {
            wrapperElement.classList.add("error");
        }
    };

    const showSuccess = () => {
        if (successElement) {
            successElement.style.display = "block";
            successElement.style.opacity = "1";
        }

        if (wrapperElement) {
            wrapperElement.classList.add("success");
        }

        setTimeout(() => {
            resetStateLabels();
        }, 3000);
    };

    const submit = async () => {
        submitBtn.classList.add("loading");
        try {
            await httpClient.post("/api/mobile-apps/send-sms", { number: input.value, appCode });
            showSuccess();
        } catch {
            showError();
        } finally {
            submitBtn.classList.remove("loading");
        }
    };

    input.addEventListener("input", function () {
        resetStateLabels();
        formatInput();
    });

    submitBtn.addEventListener("click", () => {
        resetStateLabels();
        if (validate()) {
            submit();
        }
    });
});
